import { Box } from "@mui/material";
import React from "react";
import { CODE_ERROR } from "../../utils/constants";
import SnackBarHome from "../Snackbar/SnackbarHome";

const SignupStageOne = ({
  user,
  userError,
  handleChange,
  handleCodeSubmit,
  handleCodeResend,
  open,
  setOpen,
  message,
}) => {
  return (
    <div>
      <h3 className="reset-title">We Have Emailed You</h3>
      <p className=" mb-4">
        Your OTP is on the way. To log in, enter the OTP we emailed to{" "}
        {user?.email}. It may take a minute to arrive.
      </p>

      <div className="field-col full-width">
        <label className="field-title">
          Enter your OTP<span>*</span>
        </label>
        <input
          className="field-input-login"
          name="code"
          type="text"
          required
          maxLength={6}
          value={user?.code}
          onChange={handleChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              // Only submit if code has exactly 6 characters
              if (user?.code?.length === 6) {
                e.preventDefault();
                handleCodeSubmit(e);
              } else {
                e.preventDefault(); // Prevent Enter key action if not 6 digits
              }
            }
          }}
        />
        <span className="error-message">
          {userError?.codeError ? CODE_ERROR : ""}
        </span>
      </div>
      <SnackBarHome
        open={open}
        setOpen={setOpen}
        severity="error"
        message={message}
        autoHideDuration={null}
      />
      <button
        className="btn primary-btn me-3 mb-3 test"
        onClick={(event) => {
          handleCodeSubmit(event);
        }}
        disabled={user?.code?.length !== 6}
        onKeyDown={(e) => {
          if (e.key === ' ') { // Check if the pressed key is the spacebar
              e.preventDefault(); // Prevent the default action (inserting a space)
          }
        }}
      >
        Confirm
      </button>
      <button
        className="btn primary-border-btn mb-3"
        onClick={(event) => {
          handleCodeResend(event);
        }}
        
      >
        Resend OTP
      </button>


        <div style={{ marginTop: "15px" }}>
          For any queries, please call{" "}
          <a href="tel:+918062281345">+91 80622 81345</a> or email{" "}
          <a href="mailto:support@carbn.ai">support@carbn.ai</a>.
        </div>
    </div>
  );
};

export default SignupStageOne;
